module.exports = __webpack_public_path__ + "static/media/company.92c0150e.svg";